import { render } from "./checklist.vue?vue&type=template&id=0977e203"
import script from "./checklist.vue?vue&type=script&lang=js"
export * from "./checklist.vue?vue&type=script&lang=js"

import "./checklist.vue?vue&type=style&index=0&id=0977e203&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__